import {Component, Fragment} from "react";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter"
import {funcNavigate} from "../../../../settings/utils/functions";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {NavLink} from "react-router-dom";
import {header} from "../../components/header";
import {footer} from "../../components/footer";
import {urlDynamic} from "../../../../settings/utils/urlDynamic";
import {notFound} from "../../components/notFound";
import parse from "html-react-parser"
import {MEDIA_URL} from "../../../../settings/utils/config";

class Pages extends Component {
    static contextType = simplyContext

    componentDidMount() {
        this.context.fPage(this.props.params.slug1)
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        funcNavigate(this.props.navigate, this.context)
        if (this.props.location.key !== prevProps.location.key) {
            this.context.fPage(this.props.params.slug1)
        }
    }


    render() {
        const buildHtmlString = (nodes) => {
            let htmlString = '';
            nodes.forEach(node => {
                if (node.type === 'tag') {
                    const attributes = Object.keys(node.attribs).map(attr => `${attr}="${node.attribs[attr]}"`).join(' ');
                    const innerHtml = node.children ? buildHtmlString(node.children) : '';
                    htmlString += `<${node.name} ${attributes}>${innerHtml}</${node.name}>`;
                } else if (node.type === 'text') {
                    htmlString += node.data;
                }
            });
            return htmlString;
        };

        const replaceAnchorTags = (node) => {
            if (node.name === "a") {
                let href
                if (node.attribs.url === '') {
                    if (node.attribs.back === 'true') {
                        href = MEDIA_URL + node.attribs.href
                    } else {
                        href = node.attribs.href
                    }
                } else {
                    href = '/' + node.attribs.href + urlDynamic.path[node.attribs.url]
                }
                const childrenHtml = buildHtmlString(node.children);
                return <NavLink className={node.attribs.classname} target={node.attribs.target}
                                to={href}>{parse(childrenHtml)}
                </NavLink>;
            }


            if (node.name === "img") {
                let src
                if (node.attribs.back === 'true') {
                    src = MEDIA_URL + node.attribs.src
                } else {
                    src = node.attribs.src
                }
                return <img src={src} width={node.attribs.width} height={node.attribs.height}
                            className={node.attribs.classname} alt={node.attribs.alt}/>
            }

        };
        return (
            <HelmetProvider>
                <Helmet>
                    <title>{this.props.params.slug1.replace(/-/g, ' ')}</title>
                    <link rel="canonical" href={"https://nasrme.ac.ir/" + this.props.params.slug1} />
                </Helmet>


                {this.context.state.sPage !== null ? (
                    <div className='container-fluid cFlex1 cPage'>

                        {header(this.context)}

                        <div className='row py-2 cBg7 justify-content-center cPx1 cBrudcRum'>
                            <div className='cContainer col-12'>
                                <div className='row justify-content-center'>
                                    <div className='col-12 lh-lg'>
                                        <NavLink to={urlDynamic.path.homeFa}
                                                 className='text-white cFontSize13 cHover4 cTransition'>صفحه
                                            اصلی</NavLink>
                                        {this.context.state.sPage.notFound !== true ? (
                                            this.context.state.sPage.page.dasteBandi === 'اخبار' ? (
                                                <Fragment>
                                                    <span className='mx-1 cFontSize13 text-white'>/</span>
                                                    <NavLink to={urlDynamic.path.newsAllFa}
                                                             className='text-white cFontSize13 cHover4 cTransition'>آرشیو
                                                        اخبار</NavLink>
                                                </Fragment>
                                            ) : null
                                        ) : null}
                                         {this.context.state.sPage.notFound !== true ? (
                                            this.context.state.sPage.page.dasteBandi === 'دانشنامه نصر در حوزه مرجعیت علمی' ? (
                                                <Fragment>
                                                    <span className='mx-1 cFontSize13 text-white'>/</span>
                                                    <NavLink to={'/دانشنامه-نصر-در-حوزه-مرجعیت-علمی'}
                                                             className='text-white cFontSize13 cHover4 cTransition'>دانشنامه نصر در حوزه مرجعیت علمی</NavLink>
                                                </Fragment>
                                            ) : null
                                        ) : null}
                                        {this.context.state.sPage.notFound !== true ? (
                                            this.context.state.sPage.page.dasteBandi === 'محصولات آموزشی' ? (
                                                <Fragment>
                                                    <span className='mx-1 cFontSize13 text-white'>/</span>
                                                    <NavLink to={'/محصولات-آموزشی'}
                                                             className='text-white cFontSize13 cHover4 cTransition'>محصولات آموزشی</NavLink>
                                                </Fragment>
                                            ) : null
                                        ) : null}
                                        {this.context.state.sPage.notFound !== true ? (
                                            this.context.state.sPage.page.dasteBandi === 'بسته های آموزشی' ? (
                                                <Fragment>
                                                    <span className='mx-1 cFontSize13 text-white'>/</span>
                                                    <NavLink to={'/بسته-های-آموزشی'}
                                                             className='text-white cFontSize13 cHover4 cTransition'>بسته های آموزشی</NavLink>
                                                </Fragment>
                                            ) : null
                                        ) : null}
                                        {this.context.state.sPage.notFound !== true ? (
                                            this.context.state.sPage.page.dasteBandi === 'اخبار مرجعیت علمی' ? (
                                                <Fragment>
                                                    <span className='mx-1 cFontSize13 text-white'>/</span>
                                                    <NavLink to={urlDynamic.path.newsAllMarjaiatFa}
                                                             className='text-white cFontSize13 cHover4 cTransition'>آرشیو
                                                        اخبار مرجعیت</NavLink>
                                                </Fragment>
                                            ) : null
                                        ) : null}
                                        <span className='mx-1 cFontSize13 text-white'>/</span>
                                        <h1 className='cColor2 d-inline-block mb-0 lh-lg cFontSize13'>
                                            {this.props.params.slug1.replace(/-/g, ' ')}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.context.state.sPage.notFound === true ? (
                            notFound()
                        ) : (
                            parse(this.context.state.sPage.page.desc, {replace: replaceAnchorTags})
                        )}

                        {footer()}


                    </div>
                ) : null}

            </HelmetProvider>
        )
    }
}

export default withRouter(Pages)